/**
 *
 * @author Matthew Rawson @ 14/08/2018 15:00
 * @description
 * @notes
 * - Left as class to future proof
 */
import React, {Component} from "react"
import {withRouter} from "react-router-dom"
import PropTypes from "prop-types"

import getId from "@irati/utils/id"
import GetInsWizard from "@irati/insights/apollo/client/query/InsWizard"
import GetCycleWizard from "@irati/insights/apollo/query/wizard/Cycle"
import {insWizardCloneCycleMutation} from "@irati/insights/apollo/client/mutation/insWizardCloneCycle"
import UpdateInsWizard from "@irati/insights/apollo/client/mutation/InsWizard"
import {PLACEHOLDER_SCHEDULE_ID} from "@irati/insights/constants/schedule"

import {PageWithStickyFooter} from "../../../components/Layout"
import Edit from "../../../components/Wizard/Edit/Edit"
import sitemap from "../../../routes/sitemap"
import NavigationBlocker from "../../Schedule/NavigationBlocker/NavigationBlocker"
import {Breadcrumbs} from "../../Navigation"
import EditFooter from "../Footer/EditFooter"


class EditController extends Component {
  static propTypes = {
    match: PropTypes.object.isRequired
  }

  render() {
    const idNamespace = getId("EditController", this.props)
    const {match} = this.props

    return (
      <>
        <PageWithStickyFooter id={idNamespace} footerChildren={<EditFooter />}>

          <GetInsWizard>
            {({isEditMode}) => {
              const crumbs = [sitemap.homepage, isEditMode ? sitemap.scheduleEditSummary : sitemap.wizardStep3]
              return (
                <div>
                  <Breadcrumbs id={idNamespace} crumbs={crumbs} match={match} />
                </div>
              )
            }}
          </GetInsWizard>

          <UpdateInsWizard>
            {(_, {cycle, updateCycle, client}) => {
              return (
                <GetCycleWizard
                  fetchPolicy="network-only"
                  onCompleted={({schedule}) => {
                    if (schedule.Etag !== cycle.Etag || schedule.id === PLACEHOLDER_SCHEDULE_ID) {
                      client.mutate({mutation: insWizardCloneCycleMutation})
                    }
                  }}>
                  {({schedule}) => {
                    return (
                      <Edit form={cycle} onChange={updateCycle} id={idNamespace} cycle={schedule} />
                    )
                  }}
                </GetCycleWizard>
              )
            }}
          </UpdateInsWizard>

        </PageWithStickyFooter>

        <NavigationBlocker />
      </>
    )
  }
}

export default withRouter(EditController)
